import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";


ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

function ByIndustry({ chart_data }) {
  const [label, setLabel] = useState([]);
  const [values, setValues] = useState([]);
  const [data, setData] = useState({labels: [], datasets: []});
  const [options, setOptions] = useState({});
  const [sectorMapping, setSectorMapping] = useState({});
  const [actualValues, setActualValues] = useState([]);

  useEffect(() => {
    if (!chart_data?.length) return;

    const totalAmount = chart_data.reduce(
      (sum, item) => sum + Number(item.total),
      0
    );

    const sectors = chart_data.map((item) => item.sector);

    const percentages = chart_data.map((item) =>
      Number(((item.total / totalAmount) * 100).toFixed(1))
    );

    const actualAmounts = chart_data.map(
      (item) => item.total / 10000000 // Convert to Crores
    );

    setLabel(sectors);
    setValues(percentages);
    setActualValues(actualAmounts);
  }, [chart_data]);

  let colors = [
    "#36A2EB",
    "#4BC0C0",
    "#FFCE56",
    "#FF6384",
    "#9966FF",
    "#FF9F40",
    "#2ecc71",
  ];

  useEffect(() => {
    if (!label.length) return;

    setData({
      labels: label,
      datasets: [
        {
          data: values,
          actualData: actualValues,
          backgroundColor: colors.slice(0, label.length),
          borderWidth: 0,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 40,
          bottom: 40,
          left: 50,
          right: 40,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          color: "#000",
          anchor: "end",
          align: "end",
          offset: 8,
          formatter: (value) => (value > 1 ? `${value}%` : ""),
          font: {
            weight: "bold",
            size: 12,
          },
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              const actual =
                context.dataset.actualData[context.dataIndex];

              return `${context.label}: ₹ ${actual.toFixed(2)} Cr`;
            },
          },
        },
      },
      onHover: (event, elements) => {
        event.native.target.style.cursor =
          elements.length > 0 ? "pointer" : "default";
      },
    });
  }, [label, values, actualValues]);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* LEFT: PIE CHART */}
      <div style={{ width: "100%", height: "250px" }}>
        {data?.datasets?.length > 0 && <Pie data={data} options={options} />}
      </div>

            {/* LEGEND BELOW CHART */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginTop: "15px",
          rowGap: "10px",
        }}
      >
        {label.map((item, index) => (
          <div
            key={index}
            style={{
              width: "33%", // 3 items per row
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: 14,
                height: 14,
                backgroundColor: colors[index],
                marginRight: 8,
                borderRadius: 4,
                flexShrink: 0,
              }}
            />
            <span style={{ fontSize: "12px" }}>
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ByIndustry;
